import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Faq SB',
    inputs: [],
};
